import { Button, Typography } from "@mui/material"
import { useAppSelector } from "../../app/hooks"
import { selectAnalysisData } from "../analysis/AnalysisSlice"
import { ErrorBoundary } from "react-error-boundary"
import { format } from "date-fns"
import { useState } from "react"
import { selectAuthUser } from "../auth/AuthSlice"


function FeedbackBtn(prop: any) {
  const analysisData = useAppSelector(selectAnalysisData)
  const user = useAppSelector(selectAuthUser)
  const [url, setUrl] = useState(`https://docs.google.com/forms/d/e/1FAIpQLSeBeBsT-dHkuK4WLyg67JWquLAOOVHzUisrTYMSEn4uIrQ_IA/viewform?usp=pp_url&entry.2071008149=${analysisData.slug}&entry.1430837379=${user?.email}`)
  const ErrorBoundryFallback = () => <></>
  return (<>
    <ErrorBoundary FallbackComponent={ErrorBoundryFallback} >
      <Button variant="text" size="small" sx={{ marginLeft: 2, color: 'grey.400', borderColor: 'grey.400' }}
        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')} {...prop}>Feedback</Button>
    </ErrorBoundary>
  </>)
}

export default FeedbackBtn